import TumengQRCode from './src/index.vue'

TumengQRCode.install = function(Vue) {
  Vue.component(TumengQRCode.name, TumengQRCode)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengQRCode)
}

export default TumengQRCode
